import type { ReactNode } from 'react';

export const symbol_match_case: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m244-381-37 105q-2 7-8.5 11.5T184-260q-13 0-20-10t-2-22l143-392q3-8 9-12t14-4h19q8 0 14 4t9 12l144 392q5 12-2.5 22T491-260q-8 0-14.5-4t-8.5-12l-37-105H244Zm16-44h155l-77-217h-2l-76 217Zm406 175q-51 0-83.5-26T550-346q0-47 35.5-75.5T678-450q26 0 48.5 4.5T765-433v-18q0-38-20.5-58.5T685-530q-17 0-34 5t-31 16q-8 6-16 3.5t-13-9.5q-5-7-3.5-15.5T598-545q20-13 42-19t45-6q62 0 93.5 31t31.5 93v164q0 9-6.5 15.5T788-260q-9 0-15.5-6.5T766-282v-20h-4q-16 26-43.5 39T666-250Zm0-38q36 0 68-30t32-76q-16-8-38-13t-43-5q-42 0-65.5 17.5T596-346q0 26 20.5 42t49.5 16Z"
		/>
	</svg>
);
